module.exports = __webpack_public_path__ + "static/media/0024.6c61bd06.jpg";